import {QuantityConfiguration, QuantityForm} from '../../../fields/quantity/types'
import {CreateFormInput} from '../types'

export const buildQuantityForm = ({
  configuration
}: CreateFormInput<QuantityConfiguration>): QuantityForm => {
  return {
    quantity: {
      type: 'volume',
      volume: configuration.quantity.default ?? configuration.quantity.min,
      quantityUom: configuration.quantity.uom
    }
  }
}
